export default {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    marginRight: '10px',
    cursor: 'pointer',
    '& span': {
      padding: '0 5px'
    },
    '& a': {
      color: 'inherit'
    },
    link: {
      display: 'none'
    }
  }
};
